import { useCallback } from 'modules/core/hooks/useCallback'

import fieldAttributes from 'modules/reports/store/collections/fields'

type CallbackFunctionType = (status: boolean) => void

type Props = {
  projections?: Array<string>
}

const useFields = () => {
  const load = async (
    { projections }: Props,
    loading: CallbackFunctionType,
    loaded: CallbackFunctionType
  ) => {
    loading && loading(true)

    await fieldAttributes.fetch(
      projections ? { data: { editor: 'query_builder', projections } } : {}
    )

    loaded && loaded(false)
  }

  const loadFields = useCallback(
    (
      { projections }: Props = { projections: [] },
      loading: CallbackFunctionType,
      loaded: CallbackFunctionType
    ) => {
      load({ projections }, loading, loaded).catch(() => {})
    },
    []
  )

  return loadFields
}

export default useFields
